import React, { useState, useEffect, } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import Draggable from 'react-draggable';


const useStyles = makeStyles(() => ({
    legend: {
        backgroundColor: 'lightgray',
        borderRadius: 5,
        font: "20px/28px 'Hiragino Kaku Gothic ProN', 'YuGothic', 'Meiryo', 'sans-serif'",
        padding: '1em',
        position: 'absolute',
        bottom: 30,
        left: 30,
        zIndex: 2,
        boxShadow: '0 0 1em rgb(0 0 0 / 20%)',
    },

    unit: {
        margin: '0 0 10px',
    },

    mark: {
        display: 'inline-block',
        height: 25,
        marginRight: 5,
        width: 25,
    }
}));

function Legend(props) {
    const { id, unit, items, position, onDropLegend } = props;
    const classes = useStyles();

    const onDrop = (e, position) => {
        onDropLegend(id, { x: position.x, y: position.y });
    };

    return (
        <Draggable position={position} onStop={onDrop}>
            <Box className={classes.legend} >
                <h4 className={classes.unit}>{unit}</h4>
                {items.slice().reverse().map((item, i) => {
                    return (
                        <Box key={i}>
                            {item.color
                                ? <Box className={classes.mark} style={{ backgroundColor: item.color }}></Box>
                                : <Box className={classes.mark} style={{ backgroundImage: `url(${item.image})` }}></Box>}
                            {item.value}
                        </Box>
                    );
                })}
            </Box>
        </Draggable>
    );
}

export default Legend;